<div class="form-container flex" [ngClass]="{ 'locked-row': isLocked }" [class.qi-readonly]="readOnly">
    <div
        [ngClass]="
            !question.option?.subQuestionCode && !question.option?.isSubQuestion
                ? 'col-11 p-0 m-1 flex gap-3'
                : 'flex flex-column col-11 p-0 m-1'
        "
        [attr.inert]="isLocked ? '' : null">
        @if (question.value.value1Type === 'enumRadio') {
            <div class="w-6 form-choices">
                @for (category of domainPerCode?.[question.value.domainValue1 ?? '']; track category) {
                    <div class="form-choice">
                        <p-radioButton
                            class="align-self-baseline"
                            [inputId]="id + '-' + category.value"
                            [value]="category.value"
                            [formControl]="questionInstancesInput.value1Control"
                            (ngModelChange)="notifyEscapeToParent(1)"></p-radioButton>
                        <div class="flex flex-column">
                            <label [for]="id + '-' + category.value" class="font-medium">
                                {{ 'enum.' + category.domain + '.' + category.value | translate }}
                            </label>
                            @if (
                                category.option &&
                                translateService.keyExists('enum.' + category.domain + '.' + category.value + 'Leg')
                            ) {
                                <span class="form-field__help white-space-nowrap">
                                    {{ 'enum.' + category.domain + '.' + category.value + 'Leg' | translate }}
                                </span>
                            }
                        </div>
                    </div>
                }
            </div>
        }
        @if (question.value.value1Type === 'text') {
            <p-inputgroup class="w-6">
                <input
                    [id]="id"
                    [formControl]="questionInstancesInput.value1Control"
                    [attr.aria-label]="fieldLabel(1)"
                    pInputText
                    min="0"
                    (blur)="notifyEscapeToParent(1)"
                    [readonly]="questionInstancesInput.isDisabledLike || readOnly"
                    (keydown.enter)="focusNextInput($event, id)" />
                @if (question.value.unitValue1) {
                    <p-inputgroup-addon>{{ question.value.unitValue1 | translate }}</p-inputgroup-addon>
                }
                @if (questionInstancesInput.unitFromSelectedDropdown || question.value.value2Type) {
                    <p-inputgroup-addon>
                        {{ 'unit.' + questionInstancesInput.unitFromSelectedDropdown | translate }}</p-inputgroup-addon
                    >
                }
            </p-inputgroup>
        }
        @if (question.value.value1Type === 'number' && !disabled) {
            <div
                class="qi-field"
                [ngClass]="
                    question.option?.subQuestionCode || question.pageSection === 'purchasing_digFootprint'
                        ? 'flex flex-column w-full'
                        : 'flex flex-column w-6'
                ">
                <div class="flex">
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle1') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <p class="mt-3">
                            {{ 'question.' + question.questionCode + '.entryTitle1' | translate }}
                        </p>
                    }
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle1Infotip') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <span
                            [pTooltip]="'question.' + question.questionCode + '.entryTitle1Infotip' | translate"
                            class="material-symbols-outlined icon-md qi-info cursor-help">
                            info
                        </span>
                    }
                </div>
                <p-inputgroup class="qi-field__input">
                    <p-inputNumber
                        [id]="id"
                        [inputId]="id + '-input'"
                        [ariaLabel]="fieldLabel(1)"
                        [formControl]="questionInstancesInput.value1Control"
                        [ngClass]="{ 'disabled-like': maxValue1 === 0 }"
                        [readonly]="questionInstancesInput.isDisabledLike || readOnly"
                        (onBlur)="notifyEscapeToParent(1)"
                        [min]="0"
                        (keyup)="checkError($event, 1)"
                        [max]="question.option?.max ? question.option?.max : maxValue1 ? maxValue1 : undefined"
                        mode="decimal"
                        [locale]="locale"
                        [maxFractionDigits]="2"
                        [placeholder]="
                            question.value.unitValue1
                                ? question.option?.placeholdersInput1
                                    ? ('common.example'
                                      | translate: { value: question.option?.placeholdersInput1?.[0] ?? '' })
                                    : ''
                                : ('placeHolderNumberEntry' | translate)
                        "
                        (keydown.enter)="focusNextInput($event, id)"
                        isLanguageAgnostic>
                    </p-inputNumber>
                    @if (question.value.unitValue1 && !question.option?.input1UnitDisplay) {
                        <p-inputgroup-addon>
                            {{ 'unit.' + question.value.unitValue1 | translate }}
                        </p-inputgroup-addon>
                    }
                    @if (question.option?.input1UnitDisplay) {
                        <p-inputgroup-addon>
                            {{ question.option?.input1UnitDisplay ?? '' | translate }}
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
                @if (rangeError?.field === 1) {
                    <small class="p-error">{{ rangeError?.key ?? '' | translate }}</small>
                }
            </div>
        }
        @if (question.value.value1Type === 'enum') {
            <div class="qi-field flex flex-column w-6">
                @if (
                    translateService.keyExists('question.' + question.questionCode + '.entryTitle1') &&
                    (index === 0 || question.option?.subQuestionCode)
                ) {
                    <p class="mt-3">
                        {{ 'question.' + question.questionCode + '.entryTitle1' | translate }}
                    </p>
                }
                <p-select
                    class="qi-field__input"
                    [id]="id"
                    [ariaLabel]="fieldLabel(1)"
                    [formControl]="questionInstancesInput.value1Control"
                    [options]="domain1"
                    (onBlur)="notifyEscapeToParent(1)"
                    (onChange)="onEnumChangeToParent()"
                    optionValue="value"
                    [ngClass]="{
                        'disabled-dropdown': !(domain1 && domain1.length > 0) && question.isDynamic,
                        'disabled-like': questionInstancesInput.isDisabledLike,
                    }"
                    [placeholder]="
                        questionInstancesInput.value1Control.value
                            ? translateService.instant(
                                  'enum.' +
                                      domain1Map?.get(questionInstancesInput.value1Control.value)?.domain +
                                      '.' +
                                      domain1Map?.get(questionInstancesInput.value1Control.value)?.value
                              )
                            : ('common.selectOption'
                              | translate: { value: question.option?.placeholdersInput1?.[0] ?? '' })
                    "
                    [class.selected-placeholder]="
                        !questionInstancesInput.isDisabledLike && questionInstancesInput.value1Control.value
                    "
                    [readonly]="questionInstancesInput.isDisabledLike || !(domain1 && domain1.length > 0) || readOnly"
                    appendTo="body"
                    (keydown.enter)="focusNextInput($event, id)"
                    optionLabel="translatedLabel"
                    [filter]="domain1 && domain1.length > 5"
                    filterBy="translatedLabel"
                    [filterPlaceholder]="'common.search' | translate">
                    <ng-template pTemplate="item" let-item>
                        <span>{{ item.translatedLabel }}</span>
                    </ng-template>
                    <ng-template let-selectedItem pTemplate="selectedItem">
                        <span>
                            {{
                                'enum.' +
                                    domain1Map?.get(questionInstancesInput.value1Control.value)?.domain +
                                    '.' +
                                    domain1Map?.get(questionInstancesInput.value1Control.value)?.value | translate
                            }}
                        </span>
                    </ng-template>
                </p-select>
            </div>
        }
        @if (question.value.value2Type === 'text') {
            <p-inputgroup class="w-6">
                <input
                    [id]="'val_2_' + id"
                    [formControl]="questionInstancesInput.value2Control"
                    [attr.aria-label]="fieldLabel(2)"
                    pInputText
                    pKeyFilter="num"
                    step="0.01"
                    [type]="question.value.value2Type === 'text' ? 'text' : 'number'"
                    min="0"
                    (blur)="notifyEscapeToParent(2)"
                    [readonly]="questionInstancesInput.isDisabledLike || readOnly"
                    (keydown.enter)="focusNextInput($event, 'val_2_' + id)" />
                @if (question.value.unitValue2 || question.isDynamic) {
                    <p-inputgroup-addon>{{ question.value.unitValue2 ?? '' | translate }}</p-inputgroup-addon>
                }
                @if (
                    questionInstancesInput.unitFromSelectedDropdown &&
                    question.value.value2Type &&
                    !question.option?.unitFromDropDownDisable
                ) {
                    <p-inputgroup-addon>
                        {{ questionInstancesInput.unitFromSelectedDropdown | translate }}</p-inputgroup-addon
                    >
                }
            </p-inputgroup>
        }
        @if (question.value.value2Type === 'number' && !disabled) {
            <div class="qi-field flex flex-column w-6">
                <div class="flex">
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle2') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <p class="mt-3 mb-3">
                            {{ 'question.' + question.questionCode + '.entryTitle2' | translate }}
                        </p>
                    }
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle2Infotip') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <span
                            [pTooltip]="'question.' + question.questionCode + '.entryTitle2Infotip' | translate"
                            class="material-symbols-outlined icon-md qi-info cursor-help">
                            info
                        </span>
                    }
                </div>
                <p-inputgroup class="qi-field__input">
                    <p-inputNumber
                        [id]="'val_2_' + id"
                        [ariaLabel]="fieldLabel(2)"
                        [formControl]="questionInstancesInput.value2Control"
                        [ngClass]="{ 'disabled-like': questionInstancesInput.isDisabledLike || maxValue2 === 0 }"
                        (keyup)="checkError($event, 2)"
                        (onBlur)="notifyEscapeToParent(2)"
                        [min]="0"
                        [max]="question.option?.max ? question.option?.max : maxValue2 ? maxValue2 : undefined"
                        mode="decimal"
                        [locale]="locale"
                        [placeholder]="
                            question.value.unitValue2 ||
                            (questionInstancesInput.possibleUnits &&
                                questionInstancesInput.possibleUnits.length === 1 &&
                                question.value.value2Type &&
                                !question.option?.unitFromDropDownDisable)
                                ? question.option?.placeholdersInput2
                                    ? ('common.example'
                                      | translate: { value: question.option?.placeholdersInput2?.[0] ?? '' })
                                    : ''
                                : ('placeHolderNumberEntry' | translate)
                        "
                        [maxFractionDigits]="
                            question.option?.decimalPrecisionValue2 ? question.option?.decimalPrecisionValue2 : 2
                        "
                        [readonly]="questionInstancesInput.isDisabledLike || readOnly"
                        (keydown.enter)="focusNextInput($event, 'val_2_' + id)"
                        isLanguageAgnostic></p-inputNumber>
                    @if (
                        questionInstancesInput.possibleUnits &&
                        questionInstancesInput.possibleUnits.length > 1 &&
                        question.value.value3Type === undefined
                    ) {
                        <p-select
                            class="qi-unit"
                            [ariaLabel]="'advancedMeasure.form.unit' | translate"
                            [formControl]="questionInstancesInput.unitControl"
                            [options]="questionInstancesInput.possibleUnits"
                            [readonly]="readOnly"
                            (onBlur)="notifyEscapeToParent(4)"
                            appendTo="body">
                            <ng-template pTemplate="item" let-item>
                                <span>{{ 'unit.' + item | translate }}</span>
                            </ng-template>
                            <ng-template pTemplate="selectedItem" let-selectedItem>
                                <span>{{ 'unit.' + selectedItem | translate }}</span>
                            </ng-template>
                        </p-select>
                    }
                    @if (question.value.unitValue2) {
                        <p-inputgroup-addon>
                            {{ 'unit.' + question.value.unitValue2 | translate }}
                        </p-inputgroup-addon>
                    }
                    @if (
                        questionInstancesInput.possibleUnits &&
                        questionInstancesInput.possibleUnits.length === 1 &&
                        question.value.value2Type &&
                        !question.option?.unitFromDropDownDisable &&
                        !question.value.unitValue2
                    ) {
                        <p-inputgroup-addon>
                            {{ 'unit.' + questionInstancesInput.possibleUnits[0] | translate }}
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
                @if (rangeError?.field === 2) {
                    <small class="p-error">{{ rangeError?.key ?? '' | translate }}</small>
                }
            </div>
        }
        <!-- For now, this condition is enough but be careful in the future -->
        @if (question.value.value3Type === 'number' && !disabled) {
            <div class="qi-field flex flex-column w-6">
                <div class="flex align-items-center">
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle3') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <p class="mt-3 mb-3">
                            {{ 'question.' + question.questionCode + '.entryTitle3' | translate }}
                        </p>
                    }
                    @if (
                        translateService.keyExists('question.' + question.questionCode + '.entryTitle3Infotip') &&
                        (index === 0 || question.option?.subQuestionCode)
                    ) {
                        <span
                            [pTooltip]="'question.' + question.questionCode + '.entryTitle3Infotip' | translate"
                            class="material-symbols-outlined icon-md qi-info cursor-help"
                            >info</span
                        >
                    }
                </div>
                <p-inputgroup class="qi-field__input">
                    <p-inputNumber
                        [id]="'val_3_' + id"
                        [ariaLabel]="fieldLabel(3)"
                        [formControl]="questionInstancesInput.value3Control"
                        [ngClass]="{
                            'disabled-like': questionInstancesInput.isDisabledLike || question.option?.isSubQuestion,
                        }"
                        [placeholder]="
                            (question.value.unitValue3 && !question.isDynamic) || questionInstancesInput.possibleUnits
                                ? question.option?.placeholdersInput3
                                    ? ('common.example'
                                      | translate: { value: question.option?.placeholdersInput3?.[0] ?? '' })
                                    : ''
                                : ('placeHolderNumberEntry' | translate)
                        "
                        (keyup)="checkError($event, 3)"
                        (onBlur)="notifyEscapeToParent(3)"
                        [min]="0"
                        mode="decimal"
                        [locale]="locale"
                        [readonly]="
                            questionInstancesInput.isDisabledLike ||
                            (question.option?.isSubQuestion ?? false) ||
                            readOnly
                        "
                        (keydown.enter)="focusNextInput($event, 'val_3_' + id)"
                        isLanguageAgnostic></p-inputNumber>
                    @if (questionInstancesInput.possibleUnits && questionInstancesInput.possibleUnits.length > 1) {
                        <p-select
                            class="qi-unit"
                            [ariaLabel]="'advancedMeasure.form.unit' | translate"
                            [formControl]="questionInstancesInput.unitControl"
                            [options]="questionInstancesInput.possibleUnits"
                            [readonly]="readOnly"
                            (onBlur)="notifyEscapeToParent(4)">
                            <ng-template pTemplate="item" let-item>
                                <span>{{ 'unit.' + item | translate }}</span>
                            </ng-template>
                            <ng-template pTemplate="selectedItem" let-selectedItem>
                                <span>{{ 'unit.' + selectedItem | translate }}</span>
                            </ng-template>
                        </p-select>
                    }
                    @if (question.value.unitValue3) {
                        <p-inputgroup-addon>
                            {{ 'unit.' + question.value.unitValue3 | translate }}
                        </p-inputgroup-addon>
                    }
                    @if (
                        questionInstancesInput.possibleUnits &&
                        questionInstancesInput.possibleUnits.length === 1 &&
                        !question.value.unitValue3
                    ) {
                        <p-inputgroup-addon>
                            {{ 'unit.' + questionInstancesInput.possibleUnits[0] | translate }}
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
                @if (rangeError?.field === 3) {
                    <small class="p-error">{{ rangeError?.key ?? '' | translate }}</small>
                }
            </div>
        }
    </div>

    <div
        class="qi-status flex align-items-center justify-content-end"
        [class.qi-status--top]="question.value.value1Type === 'enumRadio'">
        @if (!isLocked && questionInstancesInput.isDisabledLike) {
            <span class="material-symbols-outlined qi-status__pending" aria-hidden="true">clock_loader_60</span>
        }
        @if (isLocked) {
            <span
                class="material-symbols-outlined qi-status__locked"
                role="img"
                [attr.aria-label]="'question.locked' | translate">
                lock
            </span>
        }
        @if (
            questionInstancesInput.input1UpdateFailed ||
            (questionInstancesInput.input2UpdateFailed && question.value.value2Type)
        ) {
            <span class="material-symbols-outlined qi-status__error" aria-hidden="true">error</span>
        }
        @if (
            question.isDynamic &&
            questionInstancesInput.instanceId &&
            !questionInstancesInput.isDisabledLike &&
            !question.option?.subQuestionCode &&
            !readOnly
        ) {
            <p-button
                icon="ms ms-delete"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                [ariaLabel]="'advancedMeasure.form.delete' | translate"
                (onClick)="onDeleteNotif()" />
        }
    </div>
</div>
@if (questionInstancesInput.isPrefilled) {
    <small class="form-field__help qi-prefilled">
        {{ 'question.isPrefilled' | translate }}
    </small>
}
